import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es';
import en from './locales/en';
import api from '../gql/api';
import _ from 'lodash';

// Function to fetch translations from the backend
const fetchBackendTranslations = async (locale) => {
  try {
    const { data } = await api.translations.getTranslations();

    if (data) {
      const translations = data.getTranslations.translations;

      const translationsByLang = _.groupBy(translations, 'language');

      return Object.entries(translationsByLang).reduce(
        (acc, [lang, translations]) => {
          acc[lang] = translations.reduce((obj, item) => {
            obj[item.key] = item.translation;
            return obj;
          }, {});
          return acc;
        },
        {}
      );
    }
  } catch (error) {
    console.error(`Failed to load backend translations for ${locale}:`, error);
    return {}; // Fallback to empty object
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    // defaultNS: 'translations',
    detection: {
      order: [
        'localStorage',
        'navigator',
        'querystring',
        'cookie',
        'htmlTag',
        'path',
        'subdomain',
      ],
    },
  })
  .then(async () => {
    const backendTranslations = await fetchBackendTranslations();

    // Merge backend translations into i18n
    i18n.addResourceBundle(
      'es',
      'translation',
      backendTranslations.es || {},
      true // Overwrite existing keys if needed
    );

    i18n.addResourceBundle(
      'en',
      'translation',
      backendTranslations.en || {},
      true // Overwrite existing keys if needed
    );
  });

export default i18n;
